module.exports = __webpack_public_path__ + "img/gold.3ef6ab66.svg";